const ITEMS = [
  "CAR STEREO INSTALLATION",
  "SUBWOOFER ENCLOSURES",
  "VINYL WRAPS",
  "WINDOW TINT",
  "LED CUSTOM LIGHTING",
  "HOME A/V AUTOMATION",
  "RIMS & ACCESSORIES",
  "CUSTOM FABRICATION",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="relative overflow-hidden border-y border-white/10 bg-[#0D0F14] py-6" data-testid="services-marquee">
      <div className="animate-marquee flex w-max items-center">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span
              className={`font-display text-3xl sm:text-5xl font-extrabold tracking-tight whitespace-nowrap px-6 ${
                i % 2 === 0 ? "text-white/90" : "text-outline"
              }`}
            >
              {item}
            </span>
            <span className="h-2 w-2 rotate-45 bg-[#FF5500]" />
          </span>
        ))}
      </div>
    </div>
  );
}
